import { FC, PropsWithChildren } from 'react'

export const PageTitle: FC<PropsWithChildren> = ({ children }) => (
  <h1 className="text-primary-base text-center text-2xl font-bold">{children}</h1>
)
